import posthog, { PostHog } from 'posthog-js';
import { AKUKO_APP_POSTHOG_API_KEY, AKUKO_APP_POSTHOG_HOST, ENV } from './env';
// Initialize PostHog
export const initPostHog = () => {
  posthog.init(AKUKO_APP_POSTHOG_API_KEY, {
    api_host: AKUKO_APP_POSTHOG_HOST,
    loaded: (posthog: PostHog) => {
      if (ENV === 'dev') {
        posthog.debug();
      }
    }
  });
};

// Utility functions for common tracking patterns
export const identifyUser = (email: string) => {
  posthog.identify(email);
};

export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  posthog.capture(eventName, properties);
};

export const trackPageView = () => {
  posthog.capture('$pageview');
};

export default posthog; 
